(function () {
  const FREE_SHIPPING_DEFAULT = 9900; // $99.00 in cents

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);

      const day = result.getDay();
      const isWeekday = day !== 0 && day !== 6;

      if (isWeekday) {
        added++;
      }
    }

    return result;
  }

  function formatShipDate(date) {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  }

  function buildShippingMessage(amountCents, thresholdCents, options) {
    const shipByDate = formatShipDate(addBusinessDays(new Date(), 2));
    const isProductMessage = options && options.context === 'product';
    const cartTotalCents = options && options.cartTotalCents ? options.cartTotalCents : 0;

    if (
      isProductMessage &&
      cartTotalCents > 0 &&
      cartTotalCents < thresholdCents &&
      amountCents >= thresholdCents
    ) {
      return `Add this item to unlock free shipping. Ships by ${shipByDate}.`;
    }

    if (amountCents >= thresholdCents) {
      return `Free shipping unlocked. Ships by ${shipByDate}.`;
    }

    const remaining = thresholdCents - amountCents;
    return `Add ${formatMoney(remaining)} more for free shipping. Ships by ${shipByDate}.`;
  }

  function updatePromiseElement(element, amountCents, options) {
    if (!element) return;

    const thresholdCents = parseInt(
      element.getAttribute('data-free-shipping-threshold') || FREE_SHIPPING_DEFAULT,
      10
    );

    const textElement = element.querySelector('[data-shipping-promise-text]');
    if (!textElement) return;

    textElement.textContent = buildShippingMessage(amountCents, thresholdCents, options);
  }

  function getCartTotal() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return cart.total_price || 0;
      })
      .catch(function (error) {
        console.warn('Could not read cart total for shipping promise.', error);
        return 0;
      });
  }

  function updateProductShippingPromise(cartTotalCents) {
    const promiseElement = document.querySelector('[data-product-shipping-promise]');
    if (!promiseElement) return;

    const productPrice = parseInt(
      promiseElement.getAttribute('data-current-price') || '0',
      10
    );

    const combinedAmount = cartTotalCents + productPrice;

    updatePromiseElement(promiseElement, combinedAmount, {
      context: 'product',
      cartTotalCents: cartTotalCents
    });
  }

  function updateCartShippingPromise(cartTotalCents) {
    const promiseElement = document.querySelector('[data-cart-shipping-promise]');
    if (!promiseElement) return;

    updatePromiseElement(promiseElement, cartTotalCents, {
      context: 'cart',
      cartTotalCents: cartTotalCents
    });
  }

  function updateAllShippingPromises() {
    getCartTotal().then(function (cartTotalCents) {
      updateProductShippingPromise(cartTotalCents);
      updateCartShippingPromise(cartTotalCents);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateAllShippingPromises();

    document.addEventListener('click', function (event) {
      if (
        event.target.closest('[data-cart-update]') ||
        event.target.closest('[data-cart-remove]') ||
        event.target.closest('.ajax-cart__quantity-block') ||
        event.target.closest('[name="add"]') ||
        event.target.closest('.product-form__submit')
      ) {
        setTimeout(updateAllShippingPromises, 500);
        setTimeout(updateAllShippingPromises, 1000);
        setTimeout(updateAllShippingPromises, 1500);
      }
    });

    document.addEventListener('submit', function (event) {
      if (event.target.matches('form[action*="/cart/add"]')) {
        setTimeout(updateAllShippingPromises, 500);
        setTimeout(updateAllShippingPromises, 1000);
        setTimeout(updateAllShippingPromises, 1500);
      }
    });
  });
})();